import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../Assets/images/braccet-logo.png";

function Nav() {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "For Creators", path: "/Creator" },
    { name: "For Brands", path: "/Brand" },
  ];

  return (
    <nav className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4">
      <div className={`
        flex items-center gap-2 md:gap-8 px-4 md:px-8 py-3 
        bg-white/70 backdrop-blur-xl border border-white/20 
        rounded-full shadow-[0_8px_32px_rgba(0,0,0,0.05)]
        transition-all duration-300
        ${scrolled ? "py-2 scale-95 md:scale-100" : "py-3"}
      `}>
        {/* Logo & Brand */}
        <Link to="/" className="flex items-center gap-2 pr-4 md:border-r border-gray-200">
          <img src={logo} className="w-8 h-8 rounded-full shadow-sm" alt="Braccet Logo" />
          <span className="font-['Plus_Jakarta_Sans'] text-xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent hidden sm:block">
            Braccet
          </span>
        </Link>

        {/* Navigation Links */}
        <div className="flex items-center gap-1 md:gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`
                px-2 py-1.5 md:px-4 md:py-2 rounded-full text-[11px] md:text-sm font-bold md:font-medium transition-all duration-200
                ${location.pathname === link.path 
                  ? "bg-black text-white" 
                  : "text-gray-600 hover:bg-gray-100 hover:text-black"}
              `}
            >
              <span className="hidden md:inline">{link.name}</span>
              <span className="md:hidden">
                {link.name === "For Creators" ? "Creators" : 
                 link.name === "For Brands" ? "Brands" : 
                 link.name}
              </span>
            </Link>
          ))}
        </div>

        {/* Login Action */}
        <div className="pl-2 md:pl-4 md:border-l border-gray-200">
          <Link 
            to="/login"
            className="px-4 py-1.5 md:px-5 md:py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full text-[11px] md:text-sm font-bold md:font-semibold transition-transform hover:scale-105 active:scale-95 shadow-lg shadow-blue-500/20"
          >
            Login
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Nav;
